


































































import { Component, Vue } from 'vue-property-decorator';
import Container from '@/components/Container.vue';
import SBKHeader from '@/components/layout/SBKHeader.vue';
import LogoCarousel from '@/components/layout/LogoCarousel.vue';
import { skillsList } from '@/data/skills';
import SectionRenderFactory from '@/services/section-render-factory';

@Component({
  components: {
    Container,
    SBKHeader,
    LogoCarousel
  }
})
export default class Home extends Vue {
  private skills = skillsList;

  private sectionRenderFactory: SectionRenderFactory = new SectionRenderFactory();

  // @ts-ignore
  private docData = require('@/data/home_page.json');

  mounted() {
    this.mountCardToDom(this.docData);
  }

  /**
   * Updated dom with card components
   */
  private mountCardToDom(doc: any): void {
    // @ts-ignore
    if (this.$refs.container) {
      // @ts-ignore
      this.$refs.container.innerHTML = '';
      this.sectionRenderFactory.mountInstances(this.$refs, doc);
    }
  }
}
